import { atom } from "jotai";
import { DEFAULT_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_FILTERS } from "constants/paginationConstants";

export const ordersFiltersAtom = atom({
  ...ORDER_FILTERS,
  status: [],
});

export const ordersPageAtom = atom(DEFAULT_PAGE);
export const ordersRowsPerPageAtom = atom(DEFAULT_ROWS_PER_PAGE);